var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqcicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar_chart",
    "data-name": "bar chart",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_8164",
    "data-name": "Line 8164",
    x2: 22,
    transform: "translate(1 21)",
    fill: "none",
    stroke: "#eef8ff",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23536",
    "data-name": "Rectangle 23536",
    width: 4,
    height: 9,
    transform: "translate(2 8)",
    fill: "none",
    stroke: "#eef8ff",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23537",
    "data-name": "Rectangle 23537",
    width: 4,
    height: 14,
    transform: "translate(10 3)",
    fill: "none",
    stroke: "#eef8ff",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23538",
    "data-name": "Rectangle 23538",
    width: 4,
    height: 5,
    transform: "translate(18 12)",
    fill: "none",
    stroke: "#eef8ff",
    strokeLinecap: "square",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqcicon);
export default __webpack_public_path__ + "static/media/sqcicon.f2167e78ab7904a82876137f9afb8e04.svg";
export { ForwardRef as ReactComponent };